import global from './global.json';
import search from './search.json';
import enrollment from './enrollment.json';
import ekgRecording from './ekgRecording.json';
import all from './all.json';

const bundle = {
  ...global,
  ...search,
  ...enrollment,
  ...ekgRecording,
  ...all,
};
export default bundle;



// WEBPACK FOOTER //
// ./src/bundles/en/index.js